module.exports = __webpack_public_path__ + "static/media/socks.e6f5307b.svg";